/* eslint-disable */
import { Link, useLocation } from "react-router-dom";
import DashIcon from "components/icons/DashIcon";
import { matchPath } from "react-router";

export function SidebarLinks(props) {
  //  Chakra color mode
  let location = useLocation();

  const { routes } = props;
  // verifies if routeName is the one active (in browser input)
  const activeRoute = (path) => {
    return matchPath(path, location.pathname) !== null;
  };

  const createLinks = (routes) => {
    return routes.map((route, key) => {
      if (route.hideInSidebar) return;        

      return (
        <Link to={route.layout + route.path} key={key}>
          {route.icon ? (
            <div className="relative mb-3 flex hover:cursor-pointer">
              <li className="my-[3px] flex cursor-pointer items-center px-[30px]">
                <span
                  className={`${
                    activeRoute(route.layout + route.path) === true
                      ? "font-bold text-brand-500 dark:text-white"
                      : "font-medium text-gray-600"
                  }`}
                >
                  {route.icon ? route.icon : <DashIcon />}{" "}
                </span>
                <p
                  className={`leading-1 ml-4 flex ${
                    activeRoute(route.layout + route.path) === true
                      ? "font-bold text-navy-700 dark:text-white"
                      : "font-medium text-gray-600"
                  }`}
                >
                  {route.title || route.name}
                </p>
              </li>
              {activeRoute(route.layout + route.path) ? (
                <div className="absolute right-0 top-px h-9 w-1 rounded-lg bg-brand-500 dark:bg-brand-400" />
              ) : null}
            </div>
          ) : (
            <div
              className={`relative mb-2 flex hover:cursor-pointer`}
            >
              <li
                className="my-[3px] flex cursor-pointer items-center px-[22px]"
                key={key}
              >
                <span
                  className={`flex text-sm leading-none ml-9 ${
                    activeRoute(route.path) === true
                      ? "font-medium text-navy-700 dark:text-white"
                      : "font-medium text-gray-600"
                  }`}
                >
                  { (route.title || route.name) }
                </span>
              </li>
            </div>
          )}
        </Link>
      );
    });
  };
  // BRAND
  return <>{createLinks(routes)}</>;
}

export default SidebarLinks;
